import {request} from "./request";

export function GetCourseInfo() {
  return request({
    url: 'student/GetCourseInfo',
  })
}

export function GetClubInfo() {
  return request({
    url: 'student/GetClubInfo',
  })
}

export function GetVenueRecord() {
  return request({
    url: 'student/GetVenueRecord',
  })
}

export function GetTrainRecord(sid) {
  return request({
    url: 'student/GetTrainRecord',
    params: {
      sid
    }
  })
}
export function GetClubAddTimeRecord(sid) {
  return request({
    url: 'student/GetClubAddTimeRecord',
    params: {
      sid
    }
  })
}
export function ClubAddTimeRecord(sid,titie,des,etime) {
  return request({
    url: 'student/ClubAddTimeRecord',
    params: {
      sid,titie,des,etime
    }
  })
}
export function GetStuInfoInClub(sid) {
  return request({
    url: 'student/GetStuInfoInClub',
    params: {
      sid
    }
  })
}

export function GetPhysicalTestInfo() {
  return request({
    url: 'student/GetPhysicalTestInfo',
  })
}

export function StuDropCourse() {
  return request({
    url: 'student/dropcourse',
  })
}

export function StuDropClub() {
  return request({
    url: 'student/dropClub',
  })
}

export function StuModifyVision(leftv, rightv) {
  return request({
    url: 'student/StuModifyVision',
    params: {
      leftv, rightv
    }
  })
}


export function getStuListLikeKeyByPage(key, page) {
  return request({
    url: 'student/StuListLikeKeyByPage',
    params: {
      key,
      page
    }
  })
}

export function DelStudentById(id) {
  return request({
    url: 'student/delstudentbyid',
    params: {
      id
    }
  })
}

export function ResetPwdByStuId(id) {
  return request({
    url: 'student/ResetStuPwdById',
    params: {
      id
    }
  })
}

export function ResetMultipleStuPwd(grade, level) {
  return request({
    url: 'student/ResetMultipleStuPwd',
    params: {
      grade, level
    }
  })
}

export function DelAllStudent() {
  return request({
    url: 'student/DelAllStudent',
  })
}

export function DelMultipleStudent(code, grade, level) {
  return request({
    url: 'student/DelMultipleStudent',
    params: {
      code, grade, level
    }
  })
}

export function DelOrResetCount(grade, level) {
  return request({
    url: 'student/DelOrResetCount',
    params: {
      grade, level
    }
  })
}

export function GetStudentCountByKey(key) {
  return request({
    url: 'student/GetStudentCountByKey',
    params: {
      key
    }
  })
}

export function AddStudent(gId, sNum, sName, gender, classes, school, level,campusArea) {
  return request({
    url: 'student/AddStudent',
    params: {
      gId, sNum, sName, gender, classes, school, level,campusArea
    }
  })
}
export function ModifyStudent(id,gId, sNum, sName, gender, classes, school, level,campusArea) {
  return request({
    url: 'student/ModifyStudent',
    params: {
      id,gId, sNum, sName, gender, classes, school, level,campusArea
    }
  })
}
export function ClassesSearchByKey(key) {
  return request({
    url: 'student/ClassesSearchByKey',
    params: {
      key
    }
  })
}
